var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNerdPanaBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#020617"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.44,448.07c0,.15-91.5.26-204.34.26s-204.35-.11-204.35-.26,91.47-.26,204.35-.26S441.44,447.93,441.44,448.07Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Consoles--inject-132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.28,144.11,330.2,133.69a4.89,4.89,0,0,1-3.48-6l20.42-76.63a4.9,4.9,0,0,1,6-3.48L405,61.4a4.91,4.91,0,0,1,3.48,6l-17,63.88A18.1,18.1,0,0,1,369.28,144.11Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.07,
    y: 65.06,
    width: 38.17,
    height: 26.96,
    transform: "translate(32.66 -92.39) rotate(14.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.05,111.4a4,4,0,1,1-2.82-4.88A4,4,0,0,1,374.05,111.4Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.05,111.4a4,4,0,1,1-2.82-4.88A4,4,0,0,1,374.05,111.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.53,120.8a4,4,0,1,1-2.83-4.88A4,4,0,0,1,379.53,120.8Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.53,120.8a4,4,0,1,1-2.83-4.88A4,4,0,0,1,379.53,120.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.27,111.52a11.21,11.21,0,1,1-7.95-13.72A11.21,11.21,0,0,1,359.27,111.52Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.27,111.52a11.21,11.21,0,1,1-7.95-13.72A11.21,11.21,0,0,1,359.27,111.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.05,100.9l-.66,2.49a1.38,1.38,0,0,1-1.69,1l-2.92-.78a1.37,1.37,0,0,0-1.68,1l-.82,3.07a1.36,1.36,0,0,0,1,1.68l2.93.78a1.37,1.37,0,0,1,1,1.68l-.84,3.15a1.37,1.37,0,0,0,1,1.68l3.88,1a1.38,1.38,0,0,0,1.68-1l.86-3.22a1.37,1.37,0,0,1,1.68-1l2.71.72a1.38,1.38,0,0,0,1.68-1l.82-3.08a1.39,1.39,0,0,0-1-1.68l-2.85-.76a1.38,1.38,0,0,1-1-1.68l.65-2.41a1.37,1.37,0,0,0-1-1.68l-3.73-1A1.37,1.37,0,0,0,347.05,100.9Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.72,60.8l-23.06,83s7-1.64,11-9.69c.58-1.15,5-18.64,5-18.64l5.85-21.93,7.38-27.31a3.77,3.77,0,0,0-2.81-4.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.71,152.12l27.71-7.38a3.47,3.47,0,0,0,2.46-4.25L182.41,86.17a3.47,3.47,0,0,0-4.25-2.46L141.41,93.5A3.46,3.46,0,0,0,139,97.75L151,143A12.82,12.82,0,0,0,166.71,152.12Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.27,
    y: 96.09,
    width: 27.06,
    height: 19.12,
    transform: "translate(355.18 164.79) rotate(165.08)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33,128.94a2.83,2.83,0,1,0,2-3.46A2.83,2.83,0,0,0,163.33,128.94Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33,128.94a2.83,2.83,0,1,0,2-3.46A2.83,2.83,0,0,0,163.33,128.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.45,135.61a2.83,2.83,0,1,0,2-3.46A2.83,2.83,0,0,0,159.45,135.61Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.45,135.61a2.83,2.83,0,1,0,2-3.46A2.83,2.83,0,0,0,159.45,135.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,129a7.95,7.95,0,1,0,5.63-9.73A7.94,7.94,0,0,0,173.81,129Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,129a7.95,7.95,0,1,0,5.63-9.73A7.94,7.94,0,0,0,173.81,129Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,121.5l.47,1.76a1,1,0,0,0,1.19.69l2.08-.55a1,1,0,0,1,1.19.69l.58,2.18a1,1,0,0,1-.69,1.19l-2.07.55a1,1,0,0,0-.69,1.19l.59,2.23a1,1,0,0,1-.69,1.2l-2.75.73a1,1,0,0,1-1.19-.69l-.61-2.28a1,1,0,0,0-1.19-.69l-1.92.51a1,1,0,0,1-1.19-.69l-.59-2.18a1,1,0,0,1,.7-1.19l2-.54a1,1,0,0,0,.69-1.19l-.46-1.72a1,1,0,0,1,.69-1.19l2.65-.7A1,1,0,0,1,182.47,121.5Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,93.07l16.34,58.83a12.93,12.93,0,0,1-7.79-6.87c-.42-.82-3.54-13.21-3.54-13.21l-4.14-15.55-5.23-19.36a2.67,2.67,0,0,1,2-3.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-132"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "186.16 343.46 183.78 446.31 179.24 446.31 179.53 343.72 186.16 343.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.54 342.32 224.59 446.31 229.65 446.31 211.29 342.32 202.54 342.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.2 343.46 136.79 446.31 131.74 446.31 153.88 343.04 161.2 343.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.66,244.84s24.36-1.39,21.92,26.79-3.83,56.71-12.87,66.45-100.2,10.09-107.85,2.09,14.61-7.65,18.79-7.65S174.57,335,182.91,313,189.18,243.45,224.66,244.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.23,244.86s18.61,3.81,16.87,23.29-6.61,53.58-15.65,62.28S183,341,163.78,339.82c-22.27-1.39-36.32-5.63-36.32-5.63s-4.06,2.61-2.83,4.3,12.08,8.45,64.71,7.32,49-8.89,51.15-17.37,6.77-53.71,6.14-63.65S241,246.6,226.23,244.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,282.79a2.08,2.08,0,1,0,2-2.59A2.35,2.35,0,0,0,211,282.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.33,271.38a15.31,15.31,0,0,0-.69,3.76,9,9,0,0,0,.89,3.95,8.23,8.23,0,0,0,1.33,2,9.42,9.42,0,0,1,.93,1,2,2,0,0,1,.34,1.55,18.37,18.37,0,0,1-1,2.53,7.45,7.45,0,0,0-.3,2.34,8.77,8.77,0,0,0,1,3.92,14.86,14.86,0,0,0,2.35,3s-.36-.13-.9-.56a8.66,8.66,0,0,1-1.88-2.2,8.8,8.8,0,0,1-1.23-4.14,8.47,8.47,0,0,1,.3-2.59,21.74,21.74,0,0,0,1-2.42c.19-.77-.44-1.32-1.08-2a8.44,8.44,0,0,1-1.41-2.18,8.87,8.87,0,0,1-.8-4.24,8.34,8.34,0,0,1,.64-2.82C212.07,271.67,212.29,271.36,212.33,271.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81,279.44c.11,0,0,.61.28,1.47a5.24,5.24,0,0,0,2,2.74,8.1,8.1,0,0,0,3.31,1.18c.91.13,1.5.15,1.51.26s-.58.24-1.55.23a6.74,6.74,0,0,1-3.66-1.1,4.94,4.94,0,0,1-2.12-3.2C206.46,280,206.74,279.42,206.81,279.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-132"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "387.02 286.56 86.22 286.56 86.22 294.6 102.31 294.6 94.01 447.16 98.59 447.41 106.9 294.6 370.62 294.6 377.69 447.28 382.28 447.28 375.21 294.6 387.02 294.6 387.02 286.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.17,214.16l5.51,58.35a4.68,4.68,0,0,0,4.67,4.25h83.7a4.69,4.69,0,0,0,4.69-4.69V209.48a4.7,4.7,0,0,0-4.92-4.69L111.62,209A4.7,4.7,0,0,0,107.17,214.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.74,229.72a7.1,7.1,0,1,1-7.1-7.09A7.1,7.1,0,0,1,174.74,229.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.64,224a5.73,5.73,0,1,0,5.74,5.73A5.74,5.74,0,0,0,167.64,224Zm1.88,3.25a.76.76,0,1,1-.77.76A.76.76,0,0,1,169.52,227.24Zm-4.36,0a.76.76,0,1,1-.76.76A.76.76,0,0,1,165.16,227.24Zm6,3.95a3.41,3.41,0,0,1-1.15,1.5,4.11,4.11,0,0,1-2.31.81,4,4,0,0,1-2.35-.69,3.49,3.49,0,0,1-1.24-1.43,2,2,0,0,1-.17-1.28.82.82,0,0,1,.5-.6,3.16,3.16,0,0,1,1.57.21,5.53,5.53,0,0,0,1.59.21,5.4,5.4,0,0,0,1.58-.3,3.18,3.18,0,0,1,1.55-.28.82.82,0,0,1,.54.57A2,2,0,0,1,171.19,231.19Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.18,263.35s-3.74,22.27.59,23.38h16s-5.75-17.49-3.46-24.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.56,248.67a5.09,5.09,0,1,1,0-7.2A5.09,5.09,0,0,1,160.56,248.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.68,237s-1.58-12.59-.33-12.59,2,12.59,2,12.59h-2.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.8,237s-1.59-12.59-.34-12.59,2,12.59,2,12.59h-2.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.08,237s-1.58-12.59-.33-12.59,2,12.59,2,12.59h-2.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4,237.7s0-12.68,1.25-12.52.41,12.73.41,12.73l-2.07-.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.56,237s-1.59-12.59-.34-12.59,2,12.59,2,12.59h-2.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.39 256.55 352.33 237.03 369.12 237.03 369.12 256.08 354.39 256.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.1 286.74 346.05 275.74 384.9 275.81 387.02 286.6 347.1 286.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.63 276.67 340.69 265.66 379.54 266.14 381.35 275.9 341.63 276.67",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.06,
    y: 268.88,
    width: 1.99,
    height: 24.3,
    transform: "translate(85.29 647.53) rotate(-89.89)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.82 267.16 341.42 274.59 379.21 274.21 378.01 267.41 340.82 267.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,270.45a7.84,7.84,0,0,1-1.36.08l-3.72,0c-3.14,0-7.47-.06-12.26-.14s-9.12-.18-12.26-.28l-3.71-.15a7.1,7.1,0,0,1-1.36-.12,6.64,6.64,0,0,1,1.36-.08l3.71,0c3.14,0,7.48.05,12.27.13s9.12.19,12.26.29l3.71.14A6.5,6.5,0,0,1,376,270.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,271.39a8.56,8.56,0,0,1-1.37.12l-3.74.13c-3.16.09-7.53.19-12.35.26s-9.19.1-12.35.09l-3.74,0a6.32,6.32,0,0,1-1.38-.09,8.62,8.62,0,0,1,1.38-.12l3.74-.13c3.16-.1,7.52-.19,12.35-.26s9.18-.1,12.34-.1l3.75,0A6.26,6.26,0,0,1,376,271.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.77 266.55 343.83 255.54 382.68 256.02 384.49 265.78 344.77 266.55",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.96 257.04 344.56 264.47 382.35 264.09 381.15 257.29 343.96 257.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,260.33a7.28,7.28,0,0,1-1.36.07l-3.72,0c-3.14,0-7.47-.05-12.26-.13s-9.12-.18-12.25-.28l-3.72-.15a7.1,7.1,0,0,1-1.36-.12,6.64,6.64,0,0,1,1.36-.08l3.72,0c3.13,0,7.47.05,12.26.13s9.12.19,12.26.29l3.71.14A6.5,6.5,0,0,1,379.16,260.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,261.26a6.68,6.68,0,0,1-1.37.13l-3.74.13c-3.16.09-7.53.19-12.35.25s-9.19.11-12.35.1l-3.74,0a5.89,5.89,0,0,1-1.37-.08,8.37,8.37,0,0,1,1.37-.12l3.74-.13c3.16-.1,7.53-.19,12.35-.26s9.19-.1,12.35-.1l3.74,0A7.9,7.9,0,0,1,379.16,261.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.47,241.24c.09,0-.57,1.46-1.16,3.88a8.85,8.85,0,0,0-.06,4.24,5.91,5.91,0,0,0,1.17,2.19A10.37,10.37,0,0,1,313,253.9a3.27,3.27,0,0,1-.32,2.9,18.3,18.3,0,0,1-1.61,2.08,5.82,5.82,0,0,0-1.51,3.88,6.09,6.09,0,0,0,.63,2.8c.31.62.56.92.52.95a2.7,2.7,0,0,1-.7-.85,6,6,0,0,1-.82-2.89,6.14,6.14,0,0,1,1.5-4.19,16.51,16.51,0,0,0,1.54-2,2.69,2.69,0,0,0,.28-2.45,9.89,9.89,0,0,0-1.53-2.22,6.3,6.3,0,0,1-1.23-2.38A8.86,8.86,0,0,1,310,245a18.17,18.17,0,0,1,1-2.81A4.26,4.26,0,0,1,311.47,241.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.21,241.27c.1,0-.57,1.47-1.15,3.88a8.84,8.84,0,0,0-.07,4.24,5.91,5.91,0,0,0,1.17,2.19,10.06,10.06,0,0,1,1.62,2.35,3.24,3.24,0,0,1-.32,2.9,18.3,18.3,0,0,1-1.61,2.08,5.82,5.82,0,0,0-1.51,3.88,6.09,6.09,0,0,0,.63,2.8c.31.62.56.92.53,1a2.42,2.42,0,0,1-.7-.85,5.78,5.78,0,0,1-.83-2.89,6.14,6.14,0,0,1,1.5-4.19,17.64,17.64,0,0,0,1.55-2,2.72,2.72,0,0,0,.27-2.45,9.89,9.89,0,0,0-1.53-2.22,6.3,6.3,0,0,1-1.23-2.38,9,9,0,0,1,.17-4.46,17,17,0,0,1,1-2.81A4.05,4.05,0,0,1,316.21,241.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,273.59a6.07,6.07,0,0,0-4.05-1.19c0-.78,0-1.26,0-1.26L302.8,271s-.79,14.61,10.39,15.19c5,.27,7.88-2,9.54-4.77a11.33,11.33,0,0,0,2.51.32,5.83,5.83,0,0,0,3.49-1,4.42,4.42,0,0,0,1.69-3.73A4.28,4.28,0,0,0,329,273.59ZM327.44,279c-.95.7-2.64.58-3.74.38a20,20,0,0,0,1.11-4.8,4.21,4.21,0,0,1,2.76.66,2.2,2.2,0,0,1,.67,1.77A2.32,2.32,0,0,1,327.44,279Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.25,276.49,314.41,279l2.29,1.68a3.11,3.11,0,1,1-.67-4.35",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.25,276.49,314.41,279l2.29,1.68a3.11,3.11,0,1,1-.67-4.35",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.43,278.45a.66.66,0,0,1-.65.65.65.65,0,1,1,.65-.65Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.43,278.45a.66.66,0,0,1-.65.65.65.65,0,1,1,.65-.65Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.18,278.48a.65.65,0,1,1-.64-.65A.64.64,0,0,1,323.18,278.48Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.18,278.48a.65.65,0,1,1-.64-.65A.64.64,0,0,1,323.18,278.48Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,278.39a.65.65,0,0,1-.65.64.65.65,0,0,1,0-1.29A.65.65,0,0,1,309,278.39Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,278.39a.65.65,0,0,1-.65.64.65.65,0,0,1,0-1.29A.65.65,0,0,1,309,278.39Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.86,278.37a.65.65,0,0,1-.65.64.65.65,0,0,1,0-1.29A.65.65,0,0,1,305.86,278.37Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.86,278.37a.65.65,0,0,1-.65.64.65.65,0,0,1,0-1.29A.65.65,0,0,1,305.86,278.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.64,441.7l-.12-1.58-17.33.49.51,6.74,1.07,0c4.76-.12,24.19-1,27.28-2.17C317.5,443.8,302.64,441.7,302.64,441.7Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.92,446.71a5.93,5.93,0,0,0-2.49-3.48,5.82,5.82,0,0,0-4.11-.93l.38,4.8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.92,443s5.23,1.06,4.66,1.95-20.17,2.48-28.88,2.42V447l22.88-1.65S308.92,443.1,309.92,443Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.43,447h.3l.85,0,3.13-.11c2.64-.12,6.29-.33,10.32-.65s7.66-.7,10.29-1l3.11-.38.84-.12.3-.05a1,1,0,0,0-.3,0l-.85.08-3.12.31c-2.63.27-6.26.62-10.29.94s-7.67.55-10.31.71l-3.12.18-.85.06A2.29,2.29,0,0,0,285.43,447Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.6,445.58a6.65,6.65,0,0,1,.46-1.54,7.53,7.53,0,0,1,1-1.28,2.77,2.77,0,0,0-1.43,2.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.33,443.42c.05,0,.27-.29.48-.7s.36-.78.31-.8-.27.28-.49.7S303.27,443.39,303.33,443.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.88,442.8s.29-.17.57-.46.46-.55.42-.59-.3.16-.57.45S301.83,442.76,301.88,442.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,441.25a2.25,2.25,0,0,0,.9,0c.5,0,.9-.11.89-.17a2.06,2.06,0,0,0-.9,0C301.26,441.11,300.86,441.19,300.87,441.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.79,441.87a3.07,3.07,0,0,0,1.1-.09,6,6,0,0,0,1.15-.36,3.07,3.07,0,0,0,.65-.33.57.57,0,0,0,.25-.36.44.44,0,0,0-.2-.43,2,2,0,0,0-2.76,1.56c0,.19,0,.3,0,.3a3.18,3.18,0,0,1,.42-1,2,2,0,0,1,.9-.69,1.72,1.72,0,0,1,1.32,0c.18.12.13.33-.05.46a3.8,3.8,0,0,1-.6.32,8.16,8.16,0,0,1-1.11.38C304.2,441.81,303.78,441.84,303.79,441.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.08,441.9a1.13,1.13,0,0,0,.06-.77,1.81,1.81,0,0,0-.36-.78,1.13,1.13,0,0,0-1-.49.45.45,0,0,0-.3.54,1.22,1.22,0,0,0,.23.47,3.28,3.28,0,0,0,.58.63,1.65,1.65,0,0,0,.66.4,6.49,6.49,0,0,0-.57-.51,4.33,4.33,0,0,1-.51-.62c-.17-.23-.31-.64,0-.71s.58.2.77.41a1.87,1.87,0,0,1,.37.69A4.58,4.58,0,0,1,304.08,441.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.4,442.25s.49-.09,1.27-.06a5.42,5.42,0,0,1,4.79,3.22c.32.72.39,1.21.42,1.2s0-.13,0-.35a5.61,5.61,0,0,0-.26-.91,5.24,5.24,0,0,0-4.92-3.31,5,5,0,0,0-.95.1C285.52,442.19,285.4,442.23,285.4,442.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94,444.86a10,10,0,0,0,2.53.05,9.44,9.44,0,0,0,2.5-.41c0-.06-1.13.1-2.51.2S294,444.8,293.94,444.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.58,445.13s.11.23.24.47.22.47.28.47.07-.28-.09-.57S290.61,445.08,290.58,445.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.18,443.65s.09.21.28.38.38.26.42.22-.09-.21-.28-.38S289.22,443.61,289.18,443.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.31,443.07c0,.06.25,0,.51.11s.45.19.49.15-.12-.27-.44-.35S287.29,443,287.31,443.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,442.84c0,.05.09.13.24.18s.28,0,.29,0-.09-.14-.23-.18S286,442.78,286,442.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "281.79 412.39 285.38 440.7 302.11 440.5 299.17 408.21 281.79 412.39",
    style: {
      fill: "#f0b191"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.19 440.61 284.05 429.62 300.98 428.04 302.11 440.5 285.19 440.61",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.38,430.74a71.73,71.73,0,0,1-8.5,1,73,73,0,0,1-8.54.46,67.35,67.35,0,0,1,8.5-1A68.16,68.16,0,0,1,301.38,430.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48,431.82a71.73,71.73,0,0,1-8.5,1,73,73,0,0,1-8.54.46,67.35,67.35,0,0,1,8.5-1A70.6,70.6,0,0,1,301.48,431.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,140.92l4.44,11.92.08,0L327.46,182c3.86,7.19,2.21,19.18-9.36,23.12-9.25,3.15-28.62-5.75-28.62-5.75l2.34-16.92,18.84,5.59L303.29,157s-.62-1.1-2.13-4.37l-6.1-6.14s.34-1.8,3.31.83a2,2,0,0,0,2.87-2.54,3.13,3.13,0,0,0-5.71.64s-1.17.5-1.6-.39,1.52-4.07,4-4.14a7.31,7.31,0,0,1,3,.62s-3-7.55-2.37-7.82,1.63-.08,4.82,8.23c0,0-1.89-6.76-2-7.66s.83-1.84,1.66.26l2.62,6.66s-.65-4.58-.68-4.95c-.08-1,.85-1.18,1.33,0C306.69,137.09,308.25,140.92,308.25,140.92Z",
    style: {
      fill: "#ffd7c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.73,249.59l.23-12s-13.37-5.06-14.37-5.63L234,210.55l-16.53-4.62s-12.66,30.55-10.16,34.42c3.71,5.74,21,8.16,28.26,8.94h0l-3.18,6.62L229,259.64l1,2s9.08-5,8.86-5-.15-3.54-.15-7Z",
    style: {
      fill: "#ffd7c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.71,145.05c-.05-1.56-.82-6.74-.87-8.3a4.72,4.72,0,1,1,1.36-9.21A6.73,6.73,0,0,1,259.05,122c.1-1.82,2.07-2.93,3.85-3.36a7,7,0,0,1,4.53.19,3.41,3.41,0,0,1,2,3.75,3.91,3.91,0,0,1,6.12,4.87,4.68,4.68,0,0,1-2.74,8.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.64,174.9l18.07-1.44c.12-2.12,0-10.28,0-10.28s7.52-1.17,7.61-8.69-1.21-24.78-1.21-24.78h0a26.13,26.13,0,0,0-26.26,3.3l-1.11.86Z",
    style: {
      fill: "#ffd7c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.54,142.63A1.09,1.09,0,0,1,273,141a1.1,1.1,0,0,1,.07,1.55A1.09,1.09,0,0,1,271.54,142.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.17,140.91c-.12.13-.86-.43-1.89-.44s-1.79.53-1.9.4.06-.3.39-.54a2.55,2.55,0,0,1,3,0C274.12,140.62,274.23,140.86,274.17,140.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.6,141.82a1.1,1.1,0,0,1,.36,1.5,1.11,1.11,0,0,1-1.51.36,1.09,1.09,0,0,1,1.15-1.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.92,141.83c-.11.13-.85-.44-1.89-.45s-1.79.53-1.9.4.06-.29.39-.54a2.48,2.48,0,0,1,1.52-.48,2.6,2.6,0,0,1,1.51.51C262.87,141.53,263,141.77,262.92,141.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.07,150.37a5.29,5.29,0,0,1,1.68-.36c.27,0,.48-.09.5-.23a1.44,1.44,0,0,0-.19-.78c-.27-.68-.54-1.38-.82-2.1a29.22,29.22,0,0,1-1.77-5.53,28.75,28.75,0,0,1,2.32,5.32c.27.73.52,1.43.78,2.12a1.73,1.73,0,0,1,.14,1.13.7.7,0,0,1-.46.43,2.15,2.15,0,0,1-.46.06A5,5,0,0,1,267.07,150.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.71,151.51c1.37.39,3,1.58,5.08,1.48a2.87,2.87,0,0,1-3.38,1.14C263.16,153.3,263.71,151.51,263.71,151.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.11,153.74a11.28,11.28,0,0,1-2.31-.73,8.3,8.3,0,0,1-2.15-1.1s1,.43,2.23.91A18.28,18.28,0,0,1,268.11,153.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.81 152.14 264.5 152.56 264.89 152.86 265.27 152.37 264.81 152.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.26 152.82 265.97 153.25 266.37 153.53 266.73 153.03 266.26 152.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.62 153.27 267.33 153.7 267.73 153.98 268.08 153.48 267.62 153.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.69,163.07a17.46,17.46,0,0,1-9.8-2.78s2.31,5.41,9.82,4.73Z",
    style: {
      fill: "#f0b191"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.69,141.14c-.17,0-5.6-.42-4.7,5.92s7,3.33,7,3.15S246.69,141.14,246.69,141.14Z",
    style: {
      fill: "#ffd7c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72,148.26s-.1.09-.27.21a1.11,1.11,0,0,1-.83.13,2.75,2.75,0,0,1-1.61-2.27,3.68,3.68,0,0,1,.08-1.63,1.31,1.31,0,0,1,.71-1,.56.56,0,0,1,.7.21c.11.16.09.3.12.3s.12-.12,0-.38a.66.66,0,0,0-.3-.36.86.86,0,0,0-.64-.07,1.55,1.55,0,0,0-1,1.14,3.8,3.8,0,0,0-.13,1.82,2.88,2.88,0,0,0,2,2.51,1.21,1.21,0,0,0,1-.31C246.73,148.42,246.74,148.27,246.72,148.26Z",
    style: {
      fill: "#f0b191"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,129.15a4.88,4.88,0,0,0-2.7-3.19,13.37,13.37,0,0,0-4.16-1.08c-5.05-.72-10.3-1.06-15.18.44a11.19,11.19,0,0,0-6.11,4c-1.23,1.81-2.21,4.44-1.34,6.34h0l1.19,11.06a11.08,11.08,0,0,0,2.23,0v-8.83a4.73,4.73,0,0,0,1.91-.11,5,5,0,0,0,3.55-4,5.7,5.7,0,0,0,10.36-3.31,6.93,6.93,0,0,0,6,3.55C273.63,133.93,275.9,131.55,275.4,129.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,126.12c-.12.1-.79-.58-1.78-1.14s-1.91-.81-1.88-1,1.05-.12,2.14.51S245.56,126.05,245.45,126.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.73,125c-.13.07-.67-.85-.89-2.12a3.56,3.56,0,0,1,.12-2.3,9.32,9.32,0,0,1,.4,2.21A10.33,10.33,0,0,1,245.73,125Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.26,143.7c2.13-.48,3.92-.83,4.54-.89a6.06,6.06,0,0,1-.17-1.12,5.63,5.63,0,0,1,1-3.32,5.41,5.41,0,0,1,2.54-2,5.57,5.57,0,0,1,2.91-.3,5.4,5.4,0,0,1,2.34,1,5.33,5.33,0,0,1,2,3,4.51,4.51,0,0,1,.14,1,1.18,1.18,0,0,1,0,.35s0-.48-.27-1.29a5.44,5.44,0,0,0-2.05-2.82,5.23,5.23,0,0,0-5-.58,5.06,5.06,0,0,0-2.36,1.88,5.23,5.23,0,0,0-.93,3.1,5.34,5.34,0,0,0,1.1,3,5.24,5.24,0,0,0,7.39.89,5.39,5.39,0,0,0,1.89-2.93,7.51,7.51,0,0,0,.16-1c-.17,0-.28-.07-.28-.12s.12-.11.31-.15a0,0,0,0,0,0,0,0,0,0,0,0,0,0,2.87,2.87,0,0,1,.65-.07,3.41,3.41,0,0,1,.8.06s0,0,0-.06a5.64,5.64,0,0,1,1-3.33,5.48,5.48,0,0,1,2.54-2,5.57,5.57,0,0,1,2.91-.3,5.4,5.4,0,0,1,2.34,1,5.33,5.33,0,0,1,2,3,4.51,4.51,0,0,1,.14,1,1.18,1.18,0,0,1,0,.35s0-.48-.28-1.29a5.32,5.32,0,0,0-4.28-3.72,5.21,5.21,0,0,0-2.73.32,5.23,5.23,0,0,0-3.28,5,5.25,5.25,0,0,0,1.09,3,5,5,0,0,0,2.46,1.75,5.19,5.19,0,0,0,4.93-.86,5.39,5.39,0,0,0,1.89-2.93c.19-.82.16-1.3.2-1.3a1.55,1.55,0,0,1,0,.34,4.46,4.46,0,0,1-.09,1,5.32,5.32,0,0,1-1.86,3.11,5.42,5.42,0,0,1-2.29,1.13,5.62,5.62,0,0,1-2.92-.14,5.52,5.52,0,0,1-3.8-4.85,3.41,3.41,0,0,1-.81.11,4,4,0,0,1-.64,0v0a4.46,4.46,0,0,1-.09,1,5.43,5.43,0,0,1-4.15,4.23,5.47,5.47,0,0,1-6.55-4c-.58.21-2.35.67-4.49,1.15a30.82,30.82,0,0,1-4.78.89A30.77,30.77,0,0,1,251.26,143.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.25,139.33c-.22.7-1.71.85-3.38,1s-3.18.19-3.49-.47c-.14-.33.1-.8.69-1.23a5.06,5.06,0,0,1,2.6-.89,5,5,0,0,1,2.71.49C264,138.56,264.34,139,264.25,139.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.47,138.31c-.26.68-1.5.84-2.81,1s-2.59.16-3-.48c-.16-.32,0-.77.47-1.21a3.89,3.89,0,0,1,2.24-.9,4,4,0,0,1,2.38.49C275.35,137.54,275.58,138,275.47,138.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,137.72c.12-.08.5.33.74,1s.24,1.19.1,1.22-.36-.45-.58-1S263.89,137.79,264,137.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "245.09 412.48 246.03 440.99 262.71 442.36 262.8 409.93 245.09 412.48",
    style: {
      fill: "#f0b191"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.85 440.88 245.74 429.84 262.75 429.84 262.71 442.36 245.85 440.88",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.13,443.6l0-1.59-17.31-1.12-.11,6.76,1.07.08c4.75.32,24.17,1.3,27.36.37C277.73,447.07,263.13,443.6,263.13,443.6Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,447.59a6,6,0,0,0-2.15-3.7,5.81,5.81,0,0,0-4-1.3l-.07,4.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.26,445.55s5.11,1.54,4.46,2.38-20.31.58-29-.28l0-.39,22.93.49S269.26,445.58,270.26,445.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.51,447.25l.29,0,.85.06,3.13.18c2.64.13,6.3.26,10.33.31s7.7,0,10.34,0l3.13-.09.86,0,.29,0h-1.15l-3.13,0c-2.64,0-6.3,0-10.33,0s-7.69-.16-10.33-.25l-3.13-.11-.86,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.7,448a7,7,0,0,1,.61-1.49,6.78,6.78,0,0,1,1.08-1.19A2.81,2.81,0,0,0,268.7,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.65,445.37c.05,0,.3-.26.56-.65s.42-.74.37-.77-.29.26-.55.65A2,2,0,0,0,263.65,445.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.27,444.62s.31-.14.61-.4.51-.51.48-.55-.32.13-.62.39S262.23,444.57,262.27,444.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.41,443a2.11,2.11,0,0,0,.9.13,2,2,0,0,0,.9-.09,2.2,2.2,0,0,0-.9-.12A2,2,0,0,0,261.41,443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.26,443.88a3.2,3.2,0,0,0,1.1,0,6.11,6.11,0,0,0,1.19-.24,3,3,0,0,0,.67-.27.57.57,0,0,0,.28-.34.43.43,0,0,0-.16-.44,2,2,0,0,0-2.52.56,1.92,1.92,0,0,0-.37.73.58.58,0,0,0,0,.3,3,3,0,0,1,.52-.94,2,2,0,0,1,.95-.6,1.69,1.69,0,0,1,1.32.11c.17.13.1.33-.1.45a4.26,4.26,0,0,1-.62.26,7.92,7.92,0,0,1-1.15.28C264.68,443.85,264.26,443.84,264.26,443.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.54,443.94a1,1,0,0,0,.14-.77,1.73,1.73,0,0,0-.29-.81,1.12,1.12,0,0,0-.92-.58.44.44,0,0,0-.34.51,1.19,1.19,0,0,0,.18.49,3.25,3.25,0,0,0,.51.68,1.78,1.78,0,0,0,.63.46s-.22-.2-.52-.56a3.71,3.71,0,0,1-.45-.67c-.15-.24-.25-.66,0-.7s.55.25.72.48a1.82,1.82,0,0,1,.3.72A3.44,3.44,0,0,1,264.54,443.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.92,442.54s.49,0,1.27.06a5.44,5.44,0,0,1,2.76,1.18,5.51,5.51,0,0,1,1.7,2.47c.26.74.28,1.24.32,1.24a1.09,1.09,0,0,0,0-.35,3.79,3.79,0,0,0-.18-.93,5.24,5.24,0,0,0-1.71-2.59,5.29,5.29,0,0,0-2.87-1.17,5.67,5.67,0,0,0-1,0A1,1,0,0,0,245.92,442.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.18,445.93a9.25,9.25,0,0,0,2.51.29,10.11,10.11,0,0,0,2.52-.17c0-.07-1.13,0-2.52,0S254.19,445.87,254.18,445.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,445.89s.09.24.2.49.18.49.23.49.1-.27,0-.57S250.84,445.84,250.8,445.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,444.29s.07.22.25.4.35.3.39.26-.07-.22-.24-.4S249.59,444.25,249.55,444.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.74,443.54c0,.06.24.06.49.15s.44.23.48.19-.09-.28-.41-.39S247.72,443.49,247.74,443.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.45,443.18c0,.06.08.14.22.2s.27.06.29,0-.07-.14-.21-.2S246.47,443.13,246.45,443.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.9,432.57a72.43,72.43,0,0,1-8.55.18,68.13,68.13,0,0,1-8.55-.34,72.43,72.43,0,0,1,8.55-.18A68.13,68.13,0,0,1,262.9,432.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.9,433.65a69.93,69.93,0,0,1-8.55.18,71.86,71.86,0,0,1-8.55-.33,68.64,68.64,0,0,1,8.55-.19A73,73,0,0,1,262.9,433.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,186.85a130.39,130.39,0,0,1-18.56-8c-11.91-7-17.95-7.45-21.54-7.65l-.51-6.11L248.47,164v7.48a44,44,0,0,0-9.84,1.8c-8.06,2.91-14.58,7.37-18.3,17l-7.79,17.31,21.93,5.77,3.71-8.09.45,21.2.24,23,51.14,2.9-1.85-23.13L287,205.51l14.92,4.3Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.11,208.51a26.86,26.86,0,0,1,1.06-3.42c.73-2.23,1.67-5.06,2.71-8.19s2-6.09,2.79-8.17c.37-1,.69-1.88.92-2.45a3.59,3.59,0,0,1,.41-.88,25.29,25.29,0,0,1-1,3.45c-.72,2.23-1.64,5.07-2.65,8.21s-2.07,6.09-2.86,8.15c-.39,1-.72,1.87-1,2.43A3.17,3.17,0,0,1,298.11,208.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.25,210.18a3.63,3.63,0,0,1-.93-.06c-.59-.07-1.44-.2-2.49-.38-2.1-.36-5-1-8.12-1.78s-6-1.73-8-2.46c-1-.36-1.81-.67-2.35-.9a3.72,3.72,0,0,1-.84-.4,23.84,23.84,0,0,1,3.31,1c2,.64,4.83,1.48,8,2.31s6,1.47,8.06,1.92A25.35,25.35,0,0,1,236.25,210.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.45,250.75c-.14,0-.63-17.45-1.1-39s-.73-39-.59-39,.64,17.44,1.11,39S261.6,250.74,261.45,250.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5,186.54c.05.07-.26.27-.27.77a.91.91,0,0,0,.28.7.81.81,0,0,0,1.27-.67.88.88,0,0,0-.42-.62c-.41-.28-.75-.14-.78-.22s.33-.38,1-.11a1.27,1.27,0,0,1,.72.88,1.27,1.27,0,0,1-2.08,1.09,1.26,1.26,0,0,1-.32-1.1C262,186.59,262.5,186.47,262.5,186.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.49,207.84c.05.07-.26.27-.27.77a.9.9,0,0,0,.27.7.76.76,0,0,0,.84.05.74.74,0,0,0,.44-.71.91.91,0,0,0-.42-.63c-.41-.28-.76-.14-.78-.22s.32-.38.95-.11a1.23,1.23,0,0,1,.72.88,1.26,1.26,0,0,1-2.07,1.09,1.23,1.23,0,0,1-.32-1.1C263,207.9,263.49,207.77,263.49,207.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.49,224.57c.05.07-.26.27-.27.77a.92.92,0,0,0,.27.7.76.76,0,0,0,.84.05.75.75,0,0,0,.44-.72.93.93,0,0,0-.42-.63c-.41-.27-.76-.13-.78-.21s.32-.38.95-.11a1.23,1.23,0,0,1,.72.88,1.26,1.26,0,0,1-2.07,1.09,1.23,1.23,0,0,1-.32-1.1C263,224.62,263.49,224.5,263.49,224.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.49,239.4c0,.07-.27.27-.28.77a1,1,0,0,0,.28.7.75.75,0,0,0,.83,0,.73.73,0,0,0,.44-.71.9.9,0,0,0-.41-.63c-.41-.28-.76-.14-.79-.22s.33-.38,1-.11a1.22,1.22,0,1,1-1.67.87C264,239.45,264.49,239.33,264.49,239.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.69 171.51 275.72 213.73 278.93 213.73 276.93 172.35 273.69 171.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.82,217.22,279,252.07a16.77,16.77,0,0,0,3.07-.34c-.1-.18-2.95-34.51-2.95-34.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,213.66c0,.15-.71.28-1.6.29s-1.61-.09-1.62-.23.72-.27,1.61-.29S279,213.52,279,213.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,217.08c0,.15-.68.3-1.52.34s-1.54,0-1.54-.19.67-.29,1.51-.33S279,216.94,279,217.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25,217.3c-.15,0-.36-.83-.48-1.89s-.1-1.92.05-1.94.35.83.47,1.89S277.39,217.28,277.25,217.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.19,217.35c-.15,0-.36-.75-.47-1.72s-.1-1.76,0-1.78.36.75.47,1.72S278.33,217.33,278.19,217.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.83,217.3l.65,32.65a20.94,20.94,0,0,0,3.39.2c-.1-.2-.76-32.85-.76-32.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.06 171.87 243.51 213.73 246.73 213.73 246.28 171.41 243.06 171.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.7,213.79c0,.15-.72.24-1.6.22s-1.59-.15-1.58-.29.71-.25,1.59-.23S246.7,213.65,246.7,213.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.24,217.31c0,.14-.73.4-1.71.41s-1.74-.22-1.71-.36.78-.14,1.7-.16S247.21,217.17,247.24,217.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,217.62c-.14,0-.31-.81-.37-1.82s0-1.85.15-1.86.31.81.37,1.83S245.19,217.61,245,217.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,217.62c-.15,0-.31-.81-.37-1.82s0-1.85.15-1.86.31.81.37,1.83S246.11,217.61,246,217.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.39,167.66c-1-.54-4.69,1.54-6.72,2.77a2.35,2.35,0,0,0-.26-.75h-2.79s-.05.14-.11.37a14.61,14.61,0,0,0-5.08-2.4,1.31,1.31,0,0,0-1.59,1.25c-.08,2-.2,5.73.39,6,.94.51,4.29-1.32,6.37-2.57a4,4,0,0,0,.29.59l2.9-.18s0-.18,0-.44a15.34,15.34,0,0,0,5.38,2.61,1.31,1.31,0,0,0,1.58-1.25C267.86,171.66,268,168,267.39,167.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.64,172.58c-.14,0-.05-.7-.12-1.49s-.24-1.42-.1-1.49.56.55.62,1.45S260.77,172.63,260.64,172.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,170c0,.14-.83.51-1.93.84a4.64,4.64,0,0,1-2.08.34c-.05-.14.82-.52,1.93-.84S264.91,169.83,265,170Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.15,172.29a4.92,4.92,0,0,1-2.23-.19,5,5,0,0,1-2.14-.69,5,5,0,0,1,2.24.18A5.1,5.1,0,0,1,265.15,172.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.69,172.61c-.13,0-.41-.52-.45-1.28s.15-1.36.28-1.34.19.6.24,1.3S257.84,172.58,257.69,172.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.36,170.43a6.37,6.37,0,0,1,2.56,0,6.54,6.54,0,0,1,2.51.55,12.77,12.77,0,0,1-5.07-.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.46,172.69c0-.14.84-.58,2-1a5.08,5.08,0,0,1,2.15-.5c.06.14-.83.58-2,1S253.5,172.83,253.46,172.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.96 249.25 241.46 425.05 266.43 423.85 267.68 287.04 278.05 425.05 304.17 425.05 290.01 252.35 238.96 249.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.84 424.21 240.84 428.57 266.71 427.92 267.05 422.64 240.84 424.21",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.82 424.21 277.82 428.57 304.45 427.58 304.04 422.64 277.82 424.21",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,270.85a3.46,3.46,0,0,0,.72-.21,2.14,2.14,0,0,0,1.09-1.58,12.76,12.76,0,0,0-.18-3.09c-.14-1.2-.28-2.49-.43-3.84-.29-2.73-.53-5.2-.67-7a15.92,15.92,0,0,1-.13-2.91,15.55,15.55,0,0,1,.49,2.88c.24,1.78.53,4.25.82,7,.14,1.35.27,2.64.39,3.84a10.94,10.94,0,0,1,.07,3.21,2.31,2.31,0,0,1-1.37,1.7C264.06,271,263.76,270.87,263.77,270.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.18,251.78s.44.19.94.79a2,2,0,0,1,.45,1.36,1.52,1.52,0,0,1-.33.83,1.11,1.11,0,0,1-.91.46A1.47,1.47,0,0,1,260,254a2.06,2.06,0,0,1,.23-1.4c.38-.69.73-1,.78-1s-.18.45-.44,1.11a1.87,1.87,0,0,0-.1,1.13,1,1,0,0,0,.86.8c.41,0,.71-.42.76-.83a1.67,1.67,0,0,0-.27-1.09C261.45,252.18,261.11,251.84,261.18,251.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.54,423.45c-.14,0-.27-36.5-.27-81.5s.1-81.51.25-81.51.26,36.48.27,81.51S253.68,423.45,253.54,423.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.57,424.45a3,3,0,0,1-.05-.41c0-.29-.06-.69-.1-1.19-.08-1.09-.19-2.63-.34-4.61-.28-4-.67-9.83-1.17-17-1-14.34-2.26-34.12-3.71-56s-2.5-41.67-3.15-56c-.33-7.17-.56-13-.69-17-.06-2-.1-3.54-.14-4.62,0-.51,0-.91,0-1.2a2.47,2.47,0,0,1,0-.41,2.38,2.38,0,0,1,0,.4c0,.3.05.7.08,1.2.05,1.09.13,2.64.24,4.62.2,4,.49,9.83.85,17,.75,14.33,1.91,34.13,3.3,56s2.65,41.63,3.56,56c.42,7.15.77,12.94,1,17,.11,2,.19,3.54.24,4.62,0,.51,0,.91.05,1.2A2.12,2.12,0,0,1,290.57,424.45Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNerdPanaBg);
export default __webpack_public_path__ + "static/media/Nerd-pana-bg.ec0f743625f4207feda8e1490c07b704.svg";
export { ForwardRef as ReactComponent };